import { CommentData, MovieFullData, MovieData, MovieUpdateRequest, MovieTaxonomyData } from "../entry/server/movie.ts";
import { api, ApiResponse } from "../lib/api.ts";

/** نوع موجودیت برای جستجوی `/admin/taxonomies` */
export type TaxonomyQueryType =
  | "genre"
  | "country"
  | "language"
  | "network"
  | "category"
  | "director"
  | "actor";

/** مسیر API برای CRUD تاکسونومی: `taxonomies/{type}` */
export type TaxonomyApiType =
  | "genres"
  | "countries"
  | "languages"
  | "networks"
  | "categories"
  | "directors"
  | "actors";

/** تاکسونومی‌هایی که آپلود تصویر با multipart پشتیبانی می‌شود */
export const TAXONOMIES_WITH_IMAGE: readonly TaxonomyApiType[] = [
  "genres",
  "categories",
  "countries",
  "languages",
  "networks",
] as const;

export function taxonomySupportsImage(type: TaxonomyApiType): boolean {
  return (TAXONOMIES_WITH_IMAGE as readonly string[]).includes(type);
}

export const videoService = {
    getComments: async (page: number): Promise<ApiResponse<CommentData[]>> => {
        return await api.get<CommentData[]>({ url: `comments`, queryParams: { "page": page.toString() } });
    },
    approveComment: async (commentId: number, is_review: 'true' | 'false'): Promise<ApiResponse<any>> => {
        return await api.put<any>({ url: `comments/${commentId}/approve`, body: { is_review } });
    },
    answerComment: async (commentId: number, answer: string): Promise<ApiResponse<any>> => {
        return await api.post<any>({ url: `comments/${commentId}/answer`, body: { answer } });
    },
    deleteComment: async (commentId: number): Promise<ApiResponse<any>> => {
        return await api.delete<any>({ url: `comments/${commentId}` });
    },
    getMovies: async (page: number, search?: string): Promise<ApiResponse<MovieData[]>> => {
        return await api.get<MovieData[]>({ url: `movies`, queryParams: { "page": page.toString(), "search": search ?? "" } });
    },
    getMovie: async (id: number): Promise<ApiResponse<MovieFullData>> => {
        return await api.get<MovieFullData>({ url: `movies/${id}` });
    },
    updateMovie: async (id: number, payload: MovieUpdateRequest): Promise<ApiResponse<any>> => {
        return await api.put<any>({ url: `movies/${id}`, body: payload as unknown as Record<string, unknown> });
    },
    deleteMovie: async (id: number): Promise<ApiResponse<any>> => {
        return await api.delete<any>({ url: `movies/${id}` });
    },
    searchTaxonomies: async (q: string, type: TaxonomyQueryType): Promise<ApiResponse<MovieTaxonomyData[]>> => {
        return await api.get<MovieTaxonomyData[]>({ url: `taxonomies/search`, queryParams: { q, type } });
    },
    getTaxonomies: async (type: TaxonomyApiType, page: number, search?: string): Promise<ApiResponse<MovieTaxonomyData[]>> => {
        return await api.get<MovieTaxonomyData[]>({ url: `taxonomies/${type}`, queryParams: { "page": page.toString(), "search": search ?? "" } });
    },
    getTaxonomy: async (type: TaxonomyApiType, id: number): Promise<ApiResponse<MovieTaxonomyData>> => {
        return await api.get<MovieTaxonomyData>({ url: `taxonomies/${type}/${id}` });
    },
    updateTaxonomy: async (
        type: TaxonomyApiType,
        id: number,
        name: string,
        slug: string,
        image?: File | null
    ): Promise<ApiResponse<any>> => {
        if (taxonomySupportsImage(type)) {
            const formData = new FormData();
            formData.append("name", name);
            formData.append("slug", slug);
            if (image) {
                formData.append("image", image);
            }
            return await api.put<any>({ url: `taxonomies/${type}/${id}`, formData });
        }
        return await api.put<any>({ url: `taxonomies/${type}/${id}`, body: { name, slug } as unknown as Record<string, unknown> });
    },
    deleteTaxonomy: async (type: TaxonomyApiType, id: number): Promise<ApiResponse<any>> => {
        return await api.delete<any>({ url: `taxonomies/${type}/${id}` });
    },
};